
import download from "./download.js"

export default {
    ...download
}